import { MultiCheckboxFilterOption } from '../types';
import { MultiSelectCheckbox } from '../../components';

export const config: MultiCheckboxFilterOption = {
  id: 'omicsExplorer.filters.zygosity',
  title: {
    id: 'omicsExplorer.filters.zygosity',
    defaultMessage: 'Zygosity',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey: 'zygosity',
    checkboxOptions: [
      {
        id: 'omicsExplorer.filters.zygosity.heterozygous',
        searchValue: 'heterozygous',
        intlLabel: {
          id: 'omicsExplorer.filters.zygosity.heterozygous',
          defaultMessage: 'Heterozygous',
        },
      },
      {
        id: 'omicsExplorer.filters.zygosity.homozygous',
        searchValue: 'homozygous',
        intlLabel: {
          id: 'omicsExplorer.filters.zygosity.homozygous',
          defaultMessage: 'Homozygous',
        },
      },
      {
        id: 'omicsExplorer.filters.zygosity.reference',
        searchValue: 'reference',
        intlLabel: {
          id: 'omicsExplorer.filters.zygosity.reference',
          defaultMessage: 'Reference',
        },
      },
    ],
  },
};
